const state = {
  maxLength: 19,
  listSvgObject: [],
  canvasSize: {
    width: 0,
    height: 0,
  },
  settingModalPos: {
    left: 0,
    top: 0,
  },
  imageEdited: '',
  imageConverted: {},
  deviceType: 'landscape',
  deviceSize: {
    x: 0,
    y: 0,
  },
  showSave: false,
  showIconSave: false,
  changedSave: false,
  // Becomes false while a program is being loaded for edit and true once fully
  // loaded. Used to block a premature "Enregistrer" that would otherwise save a
  // screen before its content/background is loaded (losing it).
  editorReady: true,
  imageWidth: '',
  parentWidth: 0,
  someImage: {
    className: '',
    idParent: '',
  },
  rotationIconPos: {
    left: 0,
    top: 0,
    transform: 0,
  },
  generic: {
    selectedId: '',
    searchTitle: '',
  },
  OptionsThemeSelect: [],
  themId: 0,
  saveVideo: false,
  reclamation: false,
  causeReclamation: {},
};

const mutations = {
  animatE(state) {
    TweenMax.killTweensOf(ob.element);
    var origin = 'center center';
    var ease = ob.tween.ease || 'Expo.easeInOut';
    var duration = ob.tween.duration || 1;
    var delay = ob.tween.delay || 0;
    var subdelay = ob.tween.subdelay || 0.1;
    var repeat = ob.tween.repeat || 0;
    var el = ob.element;
    var stagger = ob.stagger;
    if (stagger) el = el.querySelector('g').children;
    if (ob.transition) {
      ob.tween.properties.forEach(p => {
        if (p.value !== '') {
          let _ease = p.ease || ease;
          let _duration = p.duration || duration;
          let _delay = p.delay || delay;
          let tob = { transformOrigin: origin, ease: _ease, delay: +_delay };
          tob[p.prop] = p.value;
          if (stagger) {
            var _subdelay = p.subdelay || subdelay;
            TweenMax.staggerFrom(el, +_duration, tob, _subdelay);
          } else {
            TweenMax.from(el, +_duration, tob);
          }
        }
      });
    }
  },
  setMaxLength(state, max) {
    state.maxLength = max;
  },
  setSettingModalPos(state, data) {
    state.settingModalPos = data;
  },

  addToListSvgObject(state, data) {
    if (state.listSvgObject.length > 0) {
      var index = state.listSvgObject.findIndex(function(item, i) {
        return item.getImgId === data.getImgId;
      });

      if (index !== -1) {
        state.listSvgObject = [
          ...state.listSvgObject.slice(0, index),
          data,
          ...state.listSvgObject.slice(index + 1),
        ];
      } else {
        state.listSvgObject.push(data);
      }
    } else {
      state.listSvgObject.push(data);
    }

  },
  duplicateSvgObject(state, data) {
    let object = null;
    let newList = state.listSvgObject;
    var ExisteId = state.listSvgObject.find(function(svg) {
      object = svg;
      return svg.getImgId === data.oldid;
    });
    if (ExisteId) {
      const newsvg = {
        getImgId: data.newid,
        file: {
          idImg: data.newid,
          conf: object.file.conf,
          svg: object.file.svg,
        },
        currentConf: {
          idImg: data.newid,
          conf: object.currentConf.conf,
          svg: object.currentConf.svg,
        },
      };
      newList.push(Object.assign({}, JSON.parse(JSON.stringify(object)), newsvg));
      let obj = {
        duplicate: true,
        duplicatedata: { newid: data.newid, oldid: data.oldid },
      };
      window.frames['svg-iframe'].contentWindow.postMessage(obj, '*');
    }
    state.listSvgObject = newList;
  },
  setImageEdited(state, image) {
    state.imageEdited = image;
  },
  setDeviceType(state, data) {
    state.deviceType = data;
  },
  setDeviceSize(state, data) {
    state.deviceSize = data;
  },
  setImageWidth(state, data) {
    state.imageWidth = data;
  },
  setParentWidth(state, data) {
    state.parentWidth = data;
  },
  setSomeImage(state, data) {
    state.someImage = data;
  },
  setCanvasSize(state, data) {
    state.canvasSize = data;
  },
  setImageConverted(state, image) {
    state.imageConverted = image;
  },
  setShowSave(state, data) {
    state.showSave = data;
  },
  setShowIconSave(state, data) {
    state.showIconSave = data;
  },
  setEditorReady(state, data) {
    state.editorReady = data;
  },
  setChangedSave(state, data) {
    state.changedSave = data;
  },
  setSelectedVideo(state, id) {
    state.generic.selectedId = id;
  },
  searchGenericVideo(state, title) {
    state.generic.searchTitle = title;
  },
  setGenericThem(state, them) {
    state.themId = them;
  },
  setOptionsThemeSelect(state, options) {
    state.OptionsThemeSelect = options;
  },
  setSaveVideo(state, value) {
    state.saveVideo = value;
  },
  setReclamation(state, value) {
    state.reclamation = value;
  },

  setCauseReclamation(state, value) {
    state.causeReclamation = value;
  },
};

const actions = {
  setSettingModalPos: ({ state, commit }, data) => commit('setSettingModalPos', data),
  setDeviceSize: ({ state, commit }, data) => commit('setDeviceSize', data),
  setImageEdited: ({ state, commit }, data) => commit('setImageEdited', data),
  setDeviceType: ({ state, commit }, data) => commit('setDeviceType', data),
  setImageWidth: ({ state, commit }, data) => commit('setImageWidth', data),
  setParentWidth: ({ state, commit }, data) => commit('setParentWidth', data),
  setSomeImage: ({ state, commit }, data) => commit('setSomeImage', data),
  setCanvasSize: ({ state, commit }, data) => commit('setCanvasSize', data),
  setImageConverted: ({ state, commit }, data) => commit('setImageConverted', data),
  setShowSave: ({ state, commit }, data) => commit('setShowSave', data),
  setChangedSave: ({ state, commit }, data) => commit('setChangedSave', data),
  addToListSvgObject: ({ state, commit }, data) => commit('addToListSvgObject', data),
  setShowIconSave: ({ state, commit }, data) => commit('setShowIconSave', data),
  setEditorReady: ({ commit }, data) => commit('setEditorReady', data),
  setSelectedVideo: ({ state, commit }, id) => commit('setSelectedVideo', id),
  searchGenericVideo: ({ state, commit }, title) => commit('searchGenericVideo', title),
  setGenericThem: ({ state, commit }, them) => commit('setGenericThem', them),
  setOptionsThemeSelect: ({ state, commit }, OptionsThemeSelect) =>
    commit('setOptionsThemeSelect', OptionsThemeSelect),
  setSaveVideo: ({ state, commit }, value) => commit('setSaveVideo', value),
  setReclamation: ({ state, commit }, value) => commit('setReclamation', value),
  setCauseReclamation: ({ state, commit }, value) => commit('setCauseReclamation', value),
  duplicateSvgObject: ({ state, commit }, data) => commit('duplicateSvgObject', data),
};

// getters are functions
const getters = {
  getmaxLength: state => state.maxLength,
  getSettingModalPos: state => state.settingModalPos,
  getDeviceSize: state => state.deviceSize,
  getImageEdited: state => state.imageEdited,
  getDeviceType: state => state.deviceType,
  getImageWidth: state => state.imageWidth,
  getParentWidth: state => state.parentWidth,
  getSomeImage: state => state.someImage,
  getCanvasSize: state => state.canvasSize,
  getImageConverted: state => state.imageConverted,
  getShowSave: state => state.showSave,
  getChangedSave: state => state.changedSave,
  getListSvgObject: state => state.listSvgObject,
  getShowIconSave: state => state.showIconSave,
  getEditorReady: state => state.editorReady,
  getSelectedVideo: state => state.generic.selectedId,
  getGenericThem: state => state.themId,
  getOptionsThemeSelect: state => state.OptionsThemeSelect,
  getSaveVideo: state => state.saveVideo,
  getReclamation: state => state.reclamation,
  getCauseReclamation: state => state.causeReclamation,
  getConfigurationSvg: state => id => state.listSvgObject.find(s => s.getImgId === id),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/common-data.js